import { useQuery } from '@tanstack/react-query';

import { setCurrentStudio } from '~entities/studios/model/studio-store';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { StudioDetails } from '../model/types';

/** Loads studio details and syncs portal timezone from the GHL account (ENR-3663). */
export const getStudioDetailsSyncedTimezoneAPI = async () => {
  const response = await baseAPI.get<StudioDetails>(
    `/studios/location?syncTimezone=1`,
  );
  const studioDetails = response.data;
  setCurrentStudio(studioDetails);
  return studioDetails;
};

export const useGetStudioDetailsSyncedTimezone = () => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DETAILS, 'sync-timezone'],
    queryFn: () => getStudioDetailsSyncedTimezoneAPI(),
  });
};
